module.exports = __webpack_public_path__ + "img/2.6291ab9a.png";